import { Popover } from '@wordpress/components';
import { __ } from '@wordpress/i18n';
import {   __experimentalHStack as HStack,__experimentalVStack as VStack,
    __experimentalText as Text, __experimentalToggleGroupControl as ToggleGroupControl,
    __experimentalToggleGroupControlOption as ToggleGroupControlOption,__experimentalToolsPanelItem as ToolsPanelItem ,
    Button
} from '@wordpress/components';

const infiniteAnimationMap = {
    none: {
        label: 'None',
        className: 'vayu_blocks_none_compoents_animation',
    },
    'icon-bounce': {
        label: 'Bounce',
        className: 'vayu_blocks_icon-bounce_compoents_animation',
    },
    'icon-bounce-left': {
        label: 'Bounce Left',
        className: 'vayu_blocks_icon-bounce-left_compoents_animation',
    },
    circleburst: {
        label: 'Circle Burst',
        className: 'vayu_blocks_circleburst_compoents_animation',
    },
    clipReveal: {
        label: 'Clip Reveal',
        className: 'vayu_blocks_clipReveal_compoents_animation',
    },
    clipRevealRight: {
        label: 'Clip Reveal Right',
        className: 'vayu_blocks_clipRevealRight_compoents_animation',
    },
    clipRevealTop: {
        label: 'Clip Reveal Top',
        className: 'vayu_blocks_clipRevealTop_compoents_animation',
    },
    clipRevealBottom: {
        label: 'Clip Reveal Bottom',
        className: 'vayu_blocks_clipRevealBottom_compoents_animation',
    },
    pulse: {
        label: 'Pulse',
        className: 'vayu_blocks_pulse_compoents_animation',
    },
    spin: {
        label: 'Spin',
        className: 'vayu_blocks_spin_compoents_animation',
    },
    flip: {
        label: 'Flip',
        className: 'vayu_blocks_flip_compoents_animation',
    },
    '3dflip': {
        label: '3D Flip',
        className: 'vayu_blocks_3dflip_compoents_animation',
    },
    swing: {
        label: 'Swing',
        className: 'vayu_blocks_swing_compoents_animation',
    },
    ripple: {
        label: 'Ripple',
        className: 'vayu_blocks_ripple_compoents_animation',
    },
};

export const Infinite = ({
    infinitePopoverAnchor,
    setisinfiniteVisible,
    animationData,
    dataKey, onChange
}) => {
    
    const selectedAnimation = animationData?.infinite?.value || 'vayu_blocks_none_compoents_animation';

    const handleinfiniteAnimationClick = (animation) => {
        const currentHoverType = animationData?.infinite?.hovertype || 'without-hvr';
    
        const updatedAnimationData = {
            ...animationData,
            infinite: {
                ...animationData.infinite,
                value: animation,
                hovertype: currentHoverType,
            },
        };
    
        onChange(dataKey, updatedAnimationData);
    };


    return (
        <Popover
            placement="left-start"
            className="vayu_blocks_toolspanel_items_popover"
            anchor={infinitePopoverAnchor}
            onClose={() => setisinfiniteVisible(false)}
            offset={35}
            resize
        >
            <VStack  style={{padding:'10px',width: '280px'}}>
                <Text>
                    <h4>{__('Infinite Animation','vayu-blocks')}</h4>
                    <p>{__('Select an infinite animation for your element.','vayu-blocks')}</p>
                </Text>

                <Text>
                    <HStack spacing="2" wrap={true}  justify="flex-start">
                        {Object.entries(infiniteAnimationMap).map(([key, { label, className }]) => (
                            <Text
                                key={key}
                                style={{ height: '59px' }}
                                className={`vayu-blocks-ihover-main-panel vayu_blocks_animation_panel_button_svg ${
                                    selectedAnimation === 'vayu_blocks_none_compoents_animation' &&
                                    className === 'vayu_blocks_none_compoents_animation'
                                        ? 'none-selected'
                                        : selectedAnimation === className
                                        ? 'selected'
                                        : ''
                                }`}
                                
                                onClick={() => handleinfiniteAnimationClick(className)}
                                title={label}
                            >
                                {key === 'none' ? (
                                        <div style={{margin:'3px 8px'}} className={`vayu-blocks-panel-ihover  vayu-blocks-none-button`} ></div>
                                ) : (
                                    <Text
                                        className={`vayu-blocks-panel-ihover height-upgrade-effect-animation vayu_blocks_animation_panel_svg ${className}`}
                                        style={{ width: '45px', height: '45px' }}
                                    />
                                )}
                            </Text>
                        ))}
                    </HStack>
                </Text>

                <br/>

                <Text>
                    <ToggleGroupControl
                        className="togglegroupcontrol-vayu-blcoks-image-border-frame"
                        __next40pxDefaultSize
                        __nextHasNoMarginBottom
                        isBlock
                        value={ animationData.infinite.hovertype || 'without-hvr' }
                        onChange={(value) => {
                            const updatedAnimationData = {
                                ...animationData,
                                infinite: {
                                    ...animationData?.infinite,
                                    hovertype: value,
                                },
                            };
                        
                            onChange(dataKey, updatedAnimationData);
                        }}
                        
                    >
                          
                        <ToggleGroupControlOption
                            label={__('Without Hover','vayu-blocks')}
                            value="without-hvr"
                        />
                        <ToggleGroupControlOption
                            label={__('Hover','vayu-blocks')}
                            value="with-hvr"
                        />
                        <ToggleGroupControlOption
                            label= {__('One Time','vayu-blocks')}
                            value="one-time" 
                        />
                            
                    </ToggleGroupControl>
                </Text>

            </VStack>
        </Popover>
    );
};

export const InfiniteEffectPanel = ({
	animationData,
	toggleinfniteVisible,
	isinfiniteVisible,
	setinfinitePopoverAnchor,
    dataKey, 
    onChange
}) => {

    const handleinfiniteAnimationClick = (animation) => {
        const currentHoverType = animationData?.infinite?.hovertype || 'without-hvr';
    
        const updatedAnimationData = {
            ...animationData,
            infinite: {
                ...animationData.infinite,
                value: animation,
                hovertype: currentHoverType,
            },
        };
    
        onChange(dataKey, updatedAnimationData);
    };
    

    const selectedInfiniteEffect =Object.entries(infiniteAnimationMap).find(([_, data]) => data.className === animationData?.infinite?.value)?.[1].label || '';


	return (
		<ToolsPanelItem
			className="vayu_blocks_animation_toolspanel_item"
			hasValue={() => !!animationData?.infinite?.value && animationData?.infinite?.value !== 'none'}
			label={__('Infinite', 'vayu-blocks')}
			onDeselect={() => handleinfiniteAnimationClick('none')}
			isShownByDefault
		>
			<Button
				ref={setinfinitePopoverAnchor}
				onClick={toggleinfniteVisible}
				className={`block-editor-panel-animation-settings__dropdown ${isinfiniteVisible ? 'is-open' : ''}`}
			>
				<HStack alignment="left">
					{!animationData?.infinite?.value || animationData?.infinite?.value === 'none' ? (
						<div className="vayu-blocks-panel-ihover vayu-blocks-none-button toolaspanel-size-none-button vayu_blocks_none"></div>
					) : (
						<div
							style={{ marginLeft: 0 }}
							className={`vayu_blocks_hstack_animation_panel_image vayu_blocks_hstack_animation_panel_image_color ${animationData?.infinite?.value}`}
						/>
					)}
					<Text style={{ marginLeft: '5px' }}>{selectedInfiniteEffect || __('None')}</Text>
				</HStack>
			</Button>
		</ToolsPanelItem>
	);
};